var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("About")]),_c('router-link',{attrs:{"to":"/projects"}},[_vm._v("Projects")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }